import { useFormik } from "formik";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jobService } from "services/job.service";
import * as Yup from "yup";

const Negotiation = ({
  show,
  handleClose,
  selectedBidId,
  setBidsData,
  bidsData
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      jobBidId: selectedBidId,
      bidAmount: 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      bidAmount: Yup.number().required("Please enter amount").min(1),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const response = await jobService.negotiateBid(values);
        if (bidsData?.bids) {
          const newData = bidsData.bids.map(item => {
            if (item._id === response.data.data.bid._id) {
              return {
                ...item,
                ...response.data.data.bid
              }
            }
            return item;
          })
          setTimeout(() => {
            setBidsData({ bids: newData, totalBids: newData.length });
            handleClose();
            toast.success('Bid negotiated successfully', { autoClose: 1000 });
          }, 2000)
        } else {
          setTimeout(() => {
            setBidsData(response.data.data);
            handleClose();
            toast.success('Bid negotiated successfully', { autoClose: 1000 });
            // navigate('/my-bids');
          }, 2000)
        }
      } catch (err) {
        setError(err?.response?.data?.message);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000)
      }
    },
  });
  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        formik.handleSubmit();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  return (
    <Modal show={show} className="modal-common" onHide={handleClose}>
      <Modal.Header closeButton>
        <p className="text-blue mb-0">Negotiation</p>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} id="negotiationForm">
          <div className="mb-30">
            <label className="py-2">Enter your negotiate amount ($)</label>
            <br />
            <div className="form-control-bg">
            <input
              type="number"
              className="form-control rounded-3 w-100"
              name="bidAmount"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            </div>
            {formik.touched.bidAmount && formik.errors.bidAmount ? (
              <span className="text-danger">{formik.errors.bidAmount}</span>
            ) : null}
          </div>

          {error && <div className="text-danger text-center">{error}</div>}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="negotiationForm"
          className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
          disabled={isLoading}
        >
          {isLoading ? 'Submitting...' : 'Submit'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default Negotiation;
